import { makeAutoObservable } from "mobx";
import { IRootStore } from "./RootStore";

export class Errorhandling {
    showError: boolean = false;
    errorMessage: string = "";

    rootStore: IRootStore;

    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);

        this.rootStore = rootStore;
    }

    displayError(error: string) {
        this.showError = true;
        this.errorMessage = error;
      }
      get getText() {
        return this.showError = true;
    
      }
    cancelErrorDialog() {
    this.showError = false;
    this.errorMessage = "";
    }
    
    handleShowError = (isShow: boolean) => {
        this.showError = isShow;
    }
    get getShowError(){
        return this.showError;
    }

    get getErrorMessage(){
        return this.errorMessage;
    }
}